export default __webpack_public_path__ + "static/media/elevate-wht-poster-2.66a89f25.jpg";